import React, { Component } from 'react'
import { Row, Col, Button, Table, Popconfirm, Modal, Select, Checkbox, Pagination } from 'antd'
import _ from 'underscore'
import PropTypes from 'prop-types'
import { api, app, config } from "../../app"
import utils from "../../utils"
import ReviewSearch from "../../components/ReviewSearch"
import common from "./common"

const Option = Select.Option

class ReDonation extends Component {
    constructor (props) {
        super(props)
        this.state = {
            data_loading: true,
            selectedRowKeys: [],
            auditList: [],
            total: 0,
            page: 1,
            dataType: '1',
            search_type: 'searchform_name',
            search_val: '',
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.dataSource(1)
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 设置值
     * @param data
     */
    setData = async (data) => app.setStateSync(this, data)

    /**
     * 数据源
     */
    dataSource = async (page = 1) => {
        await this.setState({ page, data_loading: true })
        let { dataType, search_type, search_val } = this.state, params = {
            page,
            search_val,
            search_type,
            type: dataType,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.DonateList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setData({
                selectedRowKeys: [],
                data_loading: false,
                auditList: utils.addArrayKey(data),
                total: parseInt(total || 0),
            })
        }
    }

    /**
     * 页码修改
     * @param page
     */
    handlePageChange = async (page) => {
        await this.dataSource(page)
    }

    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = async (e) => {
        let checked = e.target.checked
        let selectedRowKeys = []
        if (checked) {
            selectedRowKeys = _.range(1, this.state.auditList.length + 1)
        }
        await this.setData({ selectedRowKeys })
    }

    /**
     * 批量审核
     * @param type
     */
    handlePLReview = async (type) => {
        let { selectedRowKeys, auditList, page, total } = this.state, len = selectedRowKeys.length
        if (len === 0) {
            app.alert('请选择审核内容', 'warn')
            return
        }
        let tp = parseInt((total - len) / 20)
        tp = (total - len) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let id = selectedRowKeys.map(index => auditList[index - 1].id).join(',')
        let reviewInfo = {
            id,
            uri: api.DonateAudit,
            id_key: "id",
            source: () => this.dataSource(tp),
        }
        if (type === 1) {
            this.props.successReview(1, "", reviewInfo)
        } else if (type === 2) {
            this.props.failReview(reviewInfo)
        }
    }

    /**
     * 搜索
     * @param search_type
     * @param search_val
     */
    handleSearch = async (search_type, search_val) => {
        await this.setData({ search_type, search_val })
        await this.dataSource()
    }

    /**
     * 详情
     * @param donate_reason
     * @param describe
     */
    handleDetail = (item) => {
        Modal.info({
            title: '捐赠预览',
            destroyOnClose: true,
            centered: true,
            okText: "确定",
            width: 600,
            content: (
                <div>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠类型</Col>
                        <Col span={18}>{item.donate_type === '1' ? '内部捐赠' : '外部捐赠'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠物品名称</Col>
                        <Col span={18}>{item.goods_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠人姓名</Col>
                        <Col span={18}>{item.donate_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠人联系方式</Col>
                        <Col span={18}>{item.mobile}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠对象类型</Col>
                        <Col span={18}>{item.donate_object_type === '1' ? '队伍' : '个人'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠对象</Col>
                        <Col span={18}>{item.donate_object.object_name}({item.donate_object.object_numbering})</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠数量</Col>
                        <Col span={18}>{item.number}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠时间</Col>
                        <Col span={18}>{item.donate_time}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>提交时间</Col>
                        <Col span={18}>{item.add_time}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠原因</Col>
                        <Col span={18}>{item.donate_reason || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>物品说明</Col>
                        <Col span={18}>{item.describe || '-'}</Col>
                    </Row>
                    <Row>
                        <Col span={6}>物品图片</Col>
                        <Col span={18}>{item.images.map((img, i) => {
                            return <div style={{ height: 200, textAlign: "center" }}>
                                <img style={{ width: "auto", height: "auto", maxHeight: "100%", maxWidth: "100%" }}
                                     src={config.imgUrl + img} key={i} alt=""/>
                            </div>
                        })}</Col>
                    </Row>
                </div>
            ),
        })
    }

    render () {
        let { data_loading, auditList, total, page, selectedRowKeys, dataType } = this.state,
            tp = parseInt((total - 1) / 20)
        tp = (total - 1) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let columns = [
            {
                title: '捐赠类型',
                dataIndex: 'donate_type',
                key: 'donate_type',
                width: '6%',
                render (donate_type) {
                    return donate_type === '1' ? '内部捐赠' : (donate_type === '2' ? '外部捐赠' : '未知')
                }
            },
            {
                title: '姓名',
                dataIndex: 'donate_name',
                key: 'donate_name',
                width: '6%'
            },
            {
                title: '队员编号',
                dataIndex: 'bsrno',
                key: 'bsrno',
                width: '6%'
            },
            {
                title: '所属队伍',
                dataIndex: 'teamname',
                key: 'teamname',
                width: '12%'
            },
            {
                title: '手机号码',
                dataIndex: 'mobile',
                key: 'mobile',
                width: '8%',
            },
            {
                title: '物品名称',
                dataIndex: 'goods_name',
                key: 'goods_name',
                width: '10%',
            },
            {
                title: '数量',
                dataIndex: 'number',
                key: 'number',
                width: '6%',
            },
            {
                title: '捐赠对象',
                dataIndex: 'donate_object',
                key: 'donate_object',
                width: '12%',
                render ({ object_name, object_numbering }) {
                    return <span>
                        <div>{object_name}</div>
                        <div>({object_numbering})</div>
                    </span>
                }
            },
            {
                title: '捐赠详情',
                dataIndex: 'donate_reason',
                key: 'donate_reason',
                width: '8%',
                render: (donate_reason, item) => {
                    return <div style={{ color: '#3399CC', cursor: 'pointer' }}
                                onClick={() => this.handleDetail(item)}>捐赠预览</div>
                }
            },
            {
                title: '捐赠日期',
                dataIndex: 'donate_time',
                key: 'donate_time',
                width: '8%',
            },
        ], rowSelection = null
        if (dataType === '1') {
            columns.push({
                title: '操作',
                dataIndex: 'id',
                key: 'id',
                width: '15%',
                render: (id) => {
                    let reviewInfo = {
                        id,
                        uri: api.DonateAudit,
                        id_key: "id",
                        source: () => this.dataSource(tp),
                    }
                    let disabled = selectedRowKeys.length > 1
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <Popconfirm placement="bottom"
                                        title="确定审核通过吗？"
                                        cancelText="取消"
                                        okText="确定"
                                        onConfirm={async () => {
                                            this.props.successReview(1, "", reviewInfo)
                                        }}
                            >
                                <Button size="small" type="primary" style={{ marginRight: 20 }}
                                        disabled={disabled}>通过</Button>
                            </Popconfirm>
                            <Button size="small" type="danger" onClick={() => {
                                this.props.failReview(reviewInfo)
                            }} disabled={disabled} ghost>不通过</Button>
                        </div>
                    )
                }
            })
            rowSelection = {
                selectedRowKeys,
                onChange: async (selectedRowKeys) => {
                    await this.setData({ selectedRowKeys })
                }
            }
        } else {
            columns.push({
                title: '管理员审核',
                dataIndex: 'admin_audit',
                key: 'admin_audit',
                width: '15%',
                render: (audit, { admin_name, admin_time, detail }) => common.tableStatus(audit, admin_name, admin_time, detail)
            })
        }
        return (
            <div style={{ height: '100%' }}>
                <div>
                    <span>审核状态： </span>
                    <Select defaultValue="1" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataType: value })
                        await this.dataSource()
                    }}>
                        <Option value="1">未审核</Option>
                        <Option value="2">已审核</Option>
                    </Select>
                    <ReviewSearch onSearch={this.handleSearch}/>
                </div>
                <Table columns={columns}
                       locale={app.tbLocale(data_loading)}
                       dataSource={auditList}
                       loading={data_loading}
                       scroll={{ y: 'calc(100% - 103px)' }}
                       style={{ height: 'calc(100% - 52px)' }}
                       rowSelection={rowSelection}
                       pagination={false}
                       footer={() => {
                           return (
                               <Row hidden={auditList.length === 0}>
                                   <Col span={10}>
                                       <div hidden={dataType === '2'}>
                                           <Checkbox
                                               checked={auditList.length !== 0 && auditList.length === selectedRowKeys.length}
                                               onChange={this.handleAllSel}>全选</Checkbox>
                                           <Button style={{ margin: '0 20px' }} type="primary"
                                                   onClick={() => this.handlePLReview(1)}>通过</Button>
                                           <Button type="danger" onClick={() => this.handlePLReview(2)}>不通过</Button>
                                       </div>
                                   </Col>
                                   <Col span={14} style={{ textAlign: 'right' }}>
                                       <Pagination total={total} size="small" pageSize={20} current={page}
                                                   showTotal={(total) => `总数量：${total}`}
                                                   onChange={this.handlePageChange}/>
                                   </Col>
                               </Row>
                           )
                       }}
                       size="small"
                />
            </div>
        )
    }
}

ReDonation.propTypes = {
    successReview: PropTypes.func.isRequired,   //审核通过处理
    failReview: PropTypes.func.isRequired,  //审核失败处理
}

export default ReDonation



// WEBPACK FOOTER //
// ./src/routes/review/ReDonation.jsx